import React from 'react';
import _castArray from 'lodash/castArray';
import _includes from 'lodash/includes';
import _isNil from 'lodash/isNil';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { LocalizedMessage } from 'intl/LocalizedComponents';
// Core components
import Typography from 'components/core/Typography';

const FormItem = ({
  children, padding, paddings, title,
}) => {
  const paddingsList = _castArray(paddings);
  const paddingClasses = {
    [`pt-${padding}`]: _includes(paddingsList, 'top'),
    [`pb-${padding}`]: _includes(paddingsList, 'bottom'),
    [`py-${padding}`]: _includes(paddingsList, 'y'),
    [`pl-${padding}`]: _includes(paddingsList, 'left'),
    [`pr-${padding}`]: _includes(paddingsList, 'right'),
    [`px-${padding}`]: _includes(paddingsList, 'x'),
  };

  return (
    <div className={classnames('col-12', paddingClasses)}>
      {!_isNil(title) && (
        <div className={`pb-${padding}`}>
          <Typography type="subtitle">
            <LocalizedMessage id={title} />
          </Typography>
        </div>
      )}
      {children}
    </div>
  );
};

const paddingValues = ['top', 'bottom', 'y', 'left', 'right', 'x'];

FormItem.propTypes = {
  children: PropTypes.node.isRequired,
  padding: PropTypes.number,
  paddings: PropTypes.oneOfType([
    PropTypes.oneOf(paddingValues),
    PropTypes.arrayOf(PropTypes.oneOf(paddingValues)),
  ]),
  title: PropTypes.string,
};

FormItem.defaultProps = {
  padding: 3,
  paddings: [],
  title: null,
};

module.exports = FormItem;



// WEBPACK FOOTER //
// ./components/misc/FormItem.js